import {combineReducers} from '@reduxjs/toolkit';

import {SelectionSliceFor} from '../../../store/SelectionSliceFor';

/**
 * report-types row-selection slice (FNP-951 / FNP-918).
 *
 * Built from the shared factory rather than hand-rolled, so every module's
 * selection behaves identically. See src/features/customers/reducers/index.ts
 * for the annotated template.
 *
 * ⚠️ `entityKey` MUST match the key this reducer is registered under in
 * src/store/index.ts. A mismatch compiles cleanly and reads `undefined` at
 * runtime; src/store/tests/storeKeys.test.ts is what catches it.
 *
 * `combineReducers` wraps the slice under a `selection` key so this module
 * can later gain sibling slices (filter, sorting, visibility) without moving
 * the selection state or touching its consumers.
 */
const entityKey = 'report-types';

const selectionSlice = SelectionSliceFor(entityKey);

export const {
    addToSelection,
    addManyToSelection,
    removeFromSelection,
    clearSelection,
} = selectionSlice.actions;

export const ReportTypesReducer = combineReducers({
    selection: selectionSlice.reducer,
});
